import {SavedProperty} from "./savedProperty";
import {Product} from "./product";
import {RotationOrderProductDate} from "./rotationOrderProductDate";

export class RotationOrder {
  id: string;
  day: number;
  month: number;
  savedProperty: SavedProperty;
  products: Array<Product> = [];
  name: string;
  userId: string;
  productDates: Array<RotationOrderProductDate> = [];

  constructor(day: number = null, month: number, savedProperty: SavedProperty) {
    this.id = null;
    this.day = day;
    this.month = month;
    this.savedProperty = savedProperty;
  }
}
